import React from 'react';
import { HelpCircle } from 'lucide-react';

/**
 * SectionHeader — User-friendly section title with a "Burada ne göreceksin?" one-liner.
 * Keeps the dashboard readable for non-technical users.
 *
 * Usage:
 *   <SectionHeader
 *     id="favoriler"
 *     emoji="⭐"
 *     title="Favori Coinlerim"
 *     subtitle="Takip ettiğin coinler burada canlı güncellenir."
 *   />
 */
export default function SectionHeader({ id, emoji, title, subtitle, right }) {
    const anchor = id ? `section-${id}` : undefined;
    return (
        <div id={anchor} className="flex items-start justify-between gap-3 pt-1 scroll-mt-20" data-testid={anchor}>
            <div className="min-w-0">
                <div className="flex items-center gap-2 text-slate-100">
                    {emoji && <span className="text-base sm:text-lg leading-none">{emoji}</span>}
                    <h2 className="text-sm sm:text-base font-semibold tracking-tight">{title}</h2>
                </div>
                {subtitle && (
                    <p className="text-[11px] sm:text-xs text-slate-400 mt-1 flex items-start gap-1.5 leading-snug">
                        <HelpCircle className="h-3 w-3 mt-0.5 shrink-0 text-slate-500" />
                        <span>{subtitle}</span>
                    </p>
                )}
            </div>
            {right && <div className="shrink-0">{right}</div>}
        </div>
    );
}
